import React from 'react';
import type { Experiments } from './types';
import { getFlagSigmaOptionByName } from '.';

/**
 * Хук для получения фичаФлага из Sigma
 * @param name Имя эксперимента
 * @returns [value === expectedValue, loadingFlag]
 */
function useSigmaFeature(
  name: keyof Experiments,
  expectedValue: Experiments[keyof Experiments],
) {
  const [loading, setLoading] = React.useState(true);
  const [value, setValue] = React.useState<Experiments[keyof Experiments]>();

  const fetchSigmaFlag = React.useCallback(async () => {
    const flagValue = await getFlagSigmaOptionByName(name);
    setValue(flagValue);
    setLoading(false);
  }, []);

  React.useEffect(() => {
    fetchSigmaFlag();
  }, []);

  const matchExpectations = value === expectedValue;

  return [matchExpectations, loading] as const;
}

export default useSigmaFeature;
